import React, { useState } from 'react';

const Error = props => {

    return (<p>Error!</p>);

}

export default Error;